import { FC, memo, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import useForm from 'antd/lib/form/hooks/useForm';

import WithSettingsForm from 'components/Settings/hocs/WithSettingsForm';
import PaymentsAccountInformation from 'components/Settings/PaymentDetailsTab/PaymentsAccountInformation';
import PaymentsCountry from 'components/Settings/PaymentDetailsTab/PaymentsCountry';
import PaymentsRecipientAddress from 'components/Settings/PaymentDetailsTab/PaymentsRecipientAddress';
import SettingsSkeleton from 'components/Skeletons/Settings/SettingsSkeleton';
import { selectPaymentsSettings } from 'store/selectors/settingsSelectors';
import { getSettingsByKeyAction, updateSettingsByKeyAction } from 'store/actions/settingsActions';
import { ESettingsKey } from 'store/reducers/settingsReducer/settingsTypes';
import { useTypedSelector } from 'hooks/useTypedSelector';
import { SettingsTabPaths } from 'components/Settings/constants';

const PaymentDetailsTab: FC = () => {
  const dispatch = useDispatch();
  const { isLoading, isUpdated, ...paymentsSettings } = useTypedSelector(selectPaymentsSettings);
  const [form] = useForm();

  const handleSubmit = async() => {
    const values = form.getFieldsValue();

    await dispatch(updateSettingsByKeyAction(values, ESettingsKey.PaymentsSettings));
  };

  useEffect(() => {
    !isUpdated && dispatch(getSettingsByKeyAction(ESettingsKey.PaymentsSettings));
  }, []);

  return (
    isLoading
      ? <SettingsSkeleton />
      : <div>
        <WithSettingsForm
          form={form}
          initialValues={paymentsSettings}
          rootPath={SettingsTabPaths.PaymentDetails}
          onSubmit={handleSubmit}
        >
          <PaymentsCountry />
          <PaymentsRecipientAddress />
          <PaymentsAccountInformation />
        </WithSettingsForm>
      </div>
  );
};

export default memo(PaymentDetailsTab);
